<template>
	<div class="report-container">
		<div class="circle-decoration"></div>

		<header class="header-section">
			<h1 class="year-text">2026</h1>
			<h2 class="brand-name">富学宝典</h2>
			<div class="report-badge">二月学习报告</div>
			<p class="slogan">坚持学习的人 · 永葆青春</p>
			<p class="slogan pc-only-hint">(请使用富学宝典APP扫码查看)</p>
		</header>
		<main v-show=false class="main-content">
			<div class="input-group" :class="{ 'is-focused': isFocused }">
				<input  class="job-input" placeholder="请输入工号" v-model="jobNo" @focus="isFocused = true" @blur="isFocused = false" type="text">
				<div class="input-line"></div>
			</div>
			<button class="submit-btn" @click="debouncedSubmit" :disabled="!jobNo"> 
				<span>LET'S GO</span>
				<div class="btn-glow"></div>
			</button>
		</main>

		<footer class="footer-info" v-show="footerVisible">
			<p>版权所有：富泰华工业（深圳）有限公司</p>
			<p>备案号：<a href="https://beian.miit.gov.cn">粤ICP备13021698号</a></p>
		</footer>
	</div>
</template>

<script>
import jieliufa from '@/utils/jieliufa'

export default {
	data() {
		return {
			jobNo: '',
			isFocused: false,
			footerVisible: true,
			originalHeight: 0
		}
	},
	computed: {
		// 使用节流包装提交方法
		debouncedSubmit() {
		return jieliufa.throttle(() => {
			this.submitJobNo()
		}, 1000)
		}
	},
	mounted() {
		this.originalHeight = window.innerHeight;
		window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},
	methods: {
		handleResize() {
		// 兼容移动端键盘弹出遮挡
		this.footerVisible = window.innerHeight >= this.originalHeight - 100;
		},
		submitJobNo() {
		if (!this.jobNo.trim()) {
			this.$message({
			message: "请输入工号",
			type: "warning",
			center: true
			})
			return
		}
		this.$emit('inputJobNo', this.jobNo)
		}
	}
}
</script>

<style scoped>
/* 容器基础样式 */
.report-container {
	position: relative;
	width: 100%;
	height: 100vh;
	overflow: hidden;
	/* background: url("../../assets/26January/bg.jpg") no-repeat center;
	background-size: cover; */
	background:
					url("../../assets/26January/logo.png") right  top  no-repeat,
					url("../../assets/26January/icon.png") 49% calc(80% + 20px) no-repeat,
					url("../../assets/26February/bg.jpg")  no-repeat;
	background-size: 110px 35px, 68%,cover;
	display: flex;
	flex-direction: column;
	align-items: center;
	color: #35302f;
}

/* 默认隐藏该提示（针对手机端） */
.pc-only-hint {
  	display: none;
}

/* 头部装饰 */
.header-section {
  margin-top: 15vh;
  text-align: center;
  z-index: 2;
}

.year-text {
  font-size: 56px;
  font-weight: 900;
  margin: 0;
  line-height: 1;
  font-family: 'Gentium Basic', serif;
  letter-spacing: 2px;
}

.brand-name {
  font-size: 32px;
  color: #d03327;
  margin: 10px 0;
  text-shadow: 2px 2px 4px rgba(255,255,255,0.8);
}

.report-badge {
  display: inline-block;
  background: linear-gradient(135deg, #d03327, #ff7e5f);
  color: #fff;
  padding: 6px 24px;
  border-radius: 50px;
  font-size: 18px;
  box-shadow: 0 4px 15px rgba(208, 51, 39, 0.3);
  margin: 15px 0;
}

.slogan {
  font-size: 16px;
  color: #666;
  font-weight: 500;
  letter-spacing: 1px;
}

/* 主体交互区 */
.main-content {
  width: 80%;
  max-width: 320px;
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
}

.input-group {
  width: 100%;
  position: relative;
  margin-bottom: 40px;
  transition: all 0.3s ease;
}

.job-input {
  width: 100%;
  border: none;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(5px);
  padding: 15px;
  border-radius: 12px;
  font-size: 18px;
  text-align: center;
  outline: none;
  transition: all 0.3s;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.input-line {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: #d03327;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(-50%);
}

.input-group.is-focused .input-line {
  width: 80%;
}

.input-group.is-focused .job-input {
  background: rgba(255, 255, 255, 0.9);
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

/* 按钮样式 */
.submit-btn {
  position: relative;
  padding: 12px 40px;
  border: none;
  background: #d03327;
  color: white;
  border-radius: 12px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s;
  box-shadow: 0 8px 20px rgba(208, 51, 39, 0.4);
}

.submit-btn:active {
  transform: scale(0.95);
}

.submit-btn:disabled {
  background: #ccc;
  box-shadow: none;
  cursor: not-allowed;
}

.btn-glow {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: 0.5s;
  animation: sweep 3s infinite;
}

@keyframes sweep {
  0% { left: -100%; }
  50% { left: 100%; }
  100% { left: 100%; }
}

/* 页脚 */
.footer-info {
  position: fixed;
  bottom: 20px;
  text-align: center;
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

.footer-info a {
  color: #999;
  text-decoration: none;
}

/* 桌面端适配 */
@media screen and (min-width: 1024px) {
  .report-container {
	background:
					url("../../assets/26January/logo.png") right  top  no-repeat,
					url("../../assets/26February/code.png") 50% calc(70% + 10px) no-repeat,
					url("../../assets/26February/bg.jpg")  no-repeat;
	background-size: 110px 35px, 10%,cover;
    /* background-image: url("../../assets/26January/pcbg.jpg"); */
  }
  .pc-only-hint {
    display: block; /* 或者 inline-block */
    margin-top: 10px;
    color: #888;
    font-size: 14px;
  }
  .header-section { margin-top: 10vh; }
  .year-text { font-size: 80px; }
  .brand-name { font-size: 48px; }
  .main-content { max-width: 450px; }
  .job-input { font-size: 24px; }
}
</style>